import { createContext, useContext, useState, useEffect } from 'react'

const I18nContext = createContext()

// Import translations
import en from '../i18n/en.json'
import nb from '../i18n/nb.json'

const translations = { en, nb }

const LANGUAGES = {
  en: 'English',
  nb: 'Norsk'
}

export function I18nProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('tdo-language')
    if (saved) return saved
    const browserLang = navigator.language.split('-')[0]
    return browserLang === 'nb' || browserLang === 'no' ? 'nb' : 'en'
  })

  useEffect(() => {
    localStorage.setItem('tdo-language', language)
    document.documentElement.lang = language
  }, [language])

  const t = (key) => {
    const keys = key.split('.')
    let value = translations[language]
    for (const k of keys) {
      value = value?.[k]
    }
    return value || key
  }

  const value = {
    language,
    setLanguage,
    languages: LANGUAGES,
    t
  }

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  )
}

export function useI18n() {
  const context = useContext(I18nContext)
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider')
  }
  return context
}
